import { createRouter, createWebHistory } from "vue-router";
// import { nextTick } from 'vue';

const routes = [
  {
    path: "/",
    name: "landingPage",
    component: () => import("../views/LandingPage.vue"),
  },
  {
    path: "/sent-success",
    name: "SentSuccess",
    component: () => import("../views/AppStatus.vue"),
  },
  {
    path: "/sent-failed",
    name: "SentFailed",
    component: () => import("../views/AppStatus.vue"),
  },
  {
    path: "/error",
    name: "GlobalError",
    meta: { requiresAuth: false },
    component: () => import("../views/AppStatus.vue"),
  },
];

// Create the router instance and pass the `routes` option
const router = createRouter({
  // Use the HTML5 history mode
  history: createWebHistory(process.env.BASE_URL),

  routes, // short for `routes: routes`
});

// router.beforeEach((to) => {
//   // Use next tick to ensure the title is updated after the navigation has been confirmed
//   nextTick(() => {
//     document.title = to.meta.title || 'Default Title';
//   });
// });

export default router;
